import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component IntegrationsIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <IntegrationsIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <IntegrationsIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const IntegrationsIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    svgRef?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="IntegrationsIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path d="M10 6H5v13h13v-5h-8V6zm2 6h8v7a2 2 0 01-2 2H5a2 2 0 01-2-2V6a2 2 0 012-2h7v8zm4-7v3h3V5h-3zm-2-2h5a2 2 0 012 2v5h-7V3z" />
      <path
        stroke="#F4F5F7"
        strokeWidth={0.1}
        opacity={0.01}
        d="M.05.05h23.9v23.9H.05z"
      />
    </svg>
  )
);
IntegrationsIcon.displayName = "IntegrationsIcon";
export default IntegrationsIcon;
